@if (measurement(); as m) {
  <cosmos-measurement-info-card
    [measurement]="m"
    [device]="device()"
    [cardSubtitle]="('measurement.types.' + m.measurementType | translate) + ' - ' + ('measurement.status.awaiting-start' | translate)"
  >
    <ng-container cardFooter>
      <p-confirmdialog />
      <div class="flex flex-wrap gap-2 items-center">
        @if (rbac.canEditProject()) {
          <p-button (click)="editMeasurement()" color="primary"><i class="fa-solid fa-edit"></i> {{ "measurement.edit" | translate }}</p-button>
        }
        @if (rbac.canEditProject()) {
          <p-button (click)="finishMeasurement($event)" severity="danger"><i class="fa-solid fa-link-slash"></i>{{ "measurement.finish" | translate }}</p-button>
        }
        @if (rbac.canEditProject()) {
          <p-button (click)="changeDevice()" severity="secondary"><i class="fa-solid fa-shuffle"></i>{{ "measurement.change_device" | translate }}</p-button>
        }
        @if (rbac.canEditProject()) {
          <p-button (click)="moveStage()" severity="secondary"><i class="fa-solid fa-layer-group"></i>{{ "measurement.move_stage.action" | translate }}</p-button>
        }
      </div>
    </ng-container>
  </cosmos-measurement-info-card>
}

<p-message severity="warn" styleClass="w-full my-4">
  <i class="fa-solid fa-triangle-exclamation"></i>
  {{ (hasData() ? 'measurement.awaiting-start.subtitle' : 'measurement.awaiting-start.subtitle-no-data') | translate }}
</p-message>

<div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
  <p-card id="onboarding-measurement-start-card">
    <ng-template #title>{{ 'measurement.awaiting-start.card-title' | translate }}</ng-template>
    <ng-template #subtitle>{{ 'measurement.awaiting-start.card-subtitle' | translate }}</ng-template>

    <div class="flex items-center gap-2 mb-4">
      @if (measurement()?.measurementType; as measurementType) {
        <cosmos-measurement-liveness-badge
          [measurementType]="measurementType"
          [lastTimestamp]="lastTimestamp()"
        ></cosmos-measurement-liveness-badge>
      }
    </div>

    <div class="card-list-item">
      <div class="card-list-item-icon"><i class="fa-solid fa-list-ol"></i></div>
      <div class="item-text">
        <div class="item-title">{{ pointCount() }}</div>
        <div class="item-line">{{ 'measurement.awaiting-start.point-count' | translate }}</div>
      </div>
    </div>
    <div class="card-list-item">
      <div class="card-list-item-icon"><i class="fa-solid fa-hourglass-start"></i></div>
      <div class="item-text">
        <div class="item-title">{{ firstTimestamp() ? (firstTimestamp() | date:'dd/MM/yyyy HH:mm') : '-' }}</div>
        <div class="item-line">{{ 'measurement.awaiting-start.first-timestamp' | translate }}</div>
      </div>
    </div>
    <div class="card-list-item">
      <div class="card-list-item-icon"><i class="fa-solid fa-hourglass-end"></i></div>
      <div class="item-text">
        <div class="item-title">{{ lastTimestamp() ? (lastTimestamp() | date:'dd/MM/yyyy HH:mm') : '-' }}</div>
        <div class="item-line">{{ 'measurement.awaiting-start.last-timestamp' | translate }}</div>
      </div>
    </div>

    <ng-template #footer>
      <div class="flex flex-col gap-2">
        @if (hasData()) {
          <label for="startTimestamp" class="text-sm text-muted-color">{{ 'fields.timestampStart' | translate }}</label>
          <p-select
            inputId="startTimestamp"
            [options]="startTimestampOptions()"
            optionLabel="label"
            optionValue="value"
            [ngModel]="selectedStartTimestamp()"
            (ngModelChange)="selectedStartTimestamp.set($event)"
            styleClass="w-full"
          ></p-select>
          <button pButton [disabled]="selectedStartTimestamp() === null" (click)="startMeasurement()" class="mt-2">
            {{ 'measurement.start.button' | translate }}
          </button>
        } @else {
          <p-message severity="info" styleClass="w-full">
            <i class="fa-solid fa-circle-info"></i>
            {{ 'measurement.awaiting-start.no-data-start-hint' | translate }}
          </p-message>
          <button pButton (click)="startMeasurement()" class="mt-2">
            {{ 'measurement.start.button' | translate }}
          </button>
        }
      </div>
    </ng-template>
  </p-card>

  <div class="col-span-2 grid gap-4 min-w-0">
    <p-card id="onboarding-measurement-awaiting-start-chart" class="min-w-0">
      <ng-template #title>{{ 'measurement.chart.subtitle' | translate }}</ng-template>
      @if (chartDataObject(); as dataObject) {
        <cosmos-dynamic-line-chart
          [dataObject]="dataObject"
          [datasets]="chartDatasets()"
          [labels]="chartDatasets()"
          [chartId]="'measurement_awaiting_start'"
        ></cosmos-dynamic-line-chart>
      }
    </p-card>
  </div>
</div>
